import { installDeployVersionListener } from "@/domains/shared/services/deployVersion";
import { useEffect } from "react";

export function DeployVersionBootstrap() {
  useEffect(() => installDeployVersionListener(), []);

  return null;
}
